import { getSliceCoordinates, calculateSliceSizes } from './slice_configurations'

/**
 * Renders pie charts on canvas elements
 * Handles slice drawing, icons, and center circle
 */
export class PieChartRenderer {
  constructor(images, colorSchemes, tooltipManager, isMobile) {
    this.images = images
    this.colorSchemes = colorSchemes
    this.tooltipManager = tooltipManager
    this.isMobile = isMobile
  }

  /**
   * Draw complete pie chart for a product
   */
  makePie(data) {
    const { letterVals, type } = calculateSliceSizes(data)

    const canvas = document.getElementById(data.product_name)
    if (!canvas) return

    const ctx = canvas.getContext('2d')
    const sectionVertices = []
    const iconsToRender = []

    // Draw 8 slices (but collect icons for later)
    for (let i = 0; i < 8; i++) {
      const letter = String.fromCharCode(65 + i)
      const icon = this.makeSlice(
        sectionVertices,
        canvas,
        ctx,
        letter,
        letterVals[i],
        this.colorSchemes[data.color_scheme][letter],
        type,
        data
      )
      if (icon) {
        iconsToRender.push(icon)
      }
    }

    // Draw center circle
    this.drawCenterCircle(ctx, type)

    // Draw all icons on top
    iconsToRender.forEach(icon => {
      if (this.images[icon.name]) {
        ctx.drawImage(this.images[icon.name], icon.x, icon.y)
      }
    })

    // Setup tooltip once after all slices are drawn
    if (!this.isMobile) {
      this.tooltipManager.setupCanvasTooltip(canvas, sectionVertices, data)
    }
  }

  makeSlice(sectionVertices, canvas, ctx, letter, letterVal, color, type, data) {
    ctx.beginPath()
    ctx.moveTo(100, 100)
    const icon = this.mapCurve(sectionVertices, canvas, ctx, letter, letterVal, type, data)
    ctx.fillStyle = color
    ctx.fill()
    return icon
  }

  mapCurve(sectionVertices, canvas, ctx, lettername, letterVal, type, data) {
    const sliceKey = `${lettername}${letterVal}`
    const coords = getSliceCoordinates(sliceKey)
    
    if (coords) {
      this.createArea(sectionVertices, ctx, coords.lineTo, coords.bControl, coords.end)
      
      // Determine icon to render (but don't draw it yet)
      let iconName = coords.icon
      if (coords.useMaterialIcon) {
        iconName = data.material
      } else if (coords.useToolIcon) {
        iconName = data.scissors === 1 ? 'scissors' : 'hotknife'
      }
      
      if (iconName && coords.iconX !== undefined && coords.iconY !== undefined) {
        return { name: iconName, x: coords.iconX, y: coords.iconY }
      }
    } else {
      this.createArea(sectionVertices, ctx, [100, 100], [100, 100], [100, 100])
    }
    
    return null
  }

  createArea(sectionVertices, ctx, lineTo, bControl, end) {
    ctx.lineTo(lineTo[0], lineTo[1])
    ctx.quadraticCurveTo(bControl[0], bControl[1], end[0], end[1])
    sectionVertices.push([
      [100, lineTo[0], end[0]],
      [100, lineTo[1], end[1]]
    ])
  }

  drawCenterCircle(ctx, type) {
    const center = 100
    const radius = 12
    ctx.beginPath()
    ctx.arc(center, center, radius, 0, 2 * Math.PI, false)
    ctx.fillStyle = 'white'
    ctx.fill()
    ctx.lineWidth = 5
    ctx.strokeStyle = 'white'
    ctx.stroke()

    if (this.images[type]) {
      ctx.drawImage(this.images[type], 88, 88)
    }
  }

  cloneCanvas(oldCanvas) {
    const newCanvas = document.createElement('canvas')
    const context = newCanvas.getContext('2d')
    newCanvas.width = oldCanvas.width
    newCanvas.height = oldCanvas.height
    newCanvas.style.height = '90%'
    context.drawImage(oldCanvas, 0, 0)
    return newCanvas
  }
}
